import {
    CHECK_RIDER_LIST_START,
    CHECK_RIDER_LIST_SUCCESS,
    CHECK_RIDER_LIST_ERROR,
  } from "Constant/RentalCustomer";
  
const initialState = {
    loading: false,
    data: [],
};
  
export default function CheckRideroutReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case CHECK_RIDER_LIST_START:
        return {
          ...state,
          loading: true,
        };
      case CHECK_RIDER_LIST_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case CHECK_RIDER_LIST_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  